import * as actionTypes from "./actionTypes";

export const getInfomationStoreDetailAction = () => ({
	type: actionTypes.GET_INFOMATION_STORE_DETAIL_ACTION
});

export const setInfomationStoreDetailAction = params => ({
	type: actionTypes.SET_INFOMATION_STORE_DETAIL_ACTION,
	params
});

export const uploadImageProfileAction = params => ({
	type: actionTypes.UPLOAD_IMAGE_PROFILE_ACTION,
	params
});

export const updateInfomationStoreAction = params => ({
	type: actionTypes.UPDATE_INFOMATION_STORE_ACTION,
	params
});
